module.exports = __webpack_public_path__ + "static/media/ic_identity.7a7836d5.png";